import { AppCkeckbox } from './AppCkeckbox'

export default AppCkeckbox
